const DISMISS_KEY = 'realitycheck_save_prompt_dismissed_at';
const COOLDOWN_MS = 30 * 60 * 1000;

export function isSavePromptSuppressed() {
  try {
    const dismissedAt = sessionStorage.getItem(DISMISS_KEY);
    if (!dismissedAt) return false;
    return Date.now() - Number(dismissedAt) < COOLDOWN_MS;
  } catch {
    return false;
  }
}

export function markSavePromptDismissed() {
  try {
    sessionStorage.setItem(DISMISS_KEY, String(Date.now()));
  } catch (_) {}
}
